import { Component, OnInit, ViewChild } from '@angular/core';

import { ClienteService } from '../../services/cliente.service';

import { DatosImportacionViewModel } from '../../models/viewmodels/datosImportacionViewModel';
import { DoubleBounceComponent } from '../../shared/spinners/double-bounce/double-bounce.component'
import { CustomAlertComponent } from '../../shared/custom-alert/custom-alert.component';


@Component({
  selector: 'app-importar-archivos',
  templateUrl: './importar-archivos.component.html',
  styleUrls: ['./importar-archivos.component.scss']
})
export class ImportarArchivosComponent implements OnInit {  
  historica = new DatosImportacionViewModel();
  aplicada = new DatosImportacionViewModel();  
  archivoHistorica:File;
  archivoAplicada:File;  
  archivoComprobantes:File; 
  alert:any = {
    tipo: "success",
    titulo: "",
    mensaje: "",
    visible: false
  }

  @ViewChild('fileInputHistorica')  
  fileInputHistorica: any;

  @ViewChild('fileInputAplicada')
  fileInputAplicada: any;

  @ViewChild('fileInputPdf')
  fileInputPdf: any;

  @ViewChild(DoubleBounceComponent)
  spinner: DoubleBounceComponent;

  @ViewChild(CustomAlertComponent)
  private alertComponent: CustomAlertComponent;

  constructor(private clienteService: ClienteService) { }

  ngOnInit() {
    this.spinner.isRunning = false;
    this.aplicada.enviar = true;
    this.historica.tipo = 1;
    this.aplicada.tipo = 0;
  }

  onChangeHistorica(event: any) {
    var target = event.target || event.srcElement; //if target isn't there then take srcElement
    let files = target.files;
    this.archivoHistorica = files[0];
  }

  onChangePdf(event: any) {
    var target = event.target || event.srcElement; //if target isn't there then take srcElement
    let files = target.files;
    this.archivoComprobantes = files[0];
  }

  onChangeAplicada(event: any) {
    var target = event.target || event.srcElement; //if target isn't there then take srcElement
    let files = target.files;
    this.archivoAplicada = files[0];
  }

  onChangeChkSaldo(event: any){    
    this.historica.tipo = event.target.checked ? 1 : 2;
  }

  onSubmitAplicada(){    
    this.enviar(this.archivoAplicada, this.aplicada, this.archivoComprobantes);
  }

  onSubmit(){    
    this.enviar(this.archivoHistorica, this.historica, null);
  }

  enviar(zip:File, datos:DatosImportacionViewModel, comprobantes:File){
    this.spinner.isRunning = true;
    this.alert.visible = false;    
      this.clienteService.importarCtaCte(zip, datos, comprobantes)
          .map(result => {
              this.alert.visible = true;
              this.alert.titulo = datos.tipo == 0 ? "Cuenta Corriente Aplicada" : "Cuenta Corriente Historica";
              if(result.status == 200){
                this.alert.tipo = "success"              
                this.alert.mensaje = "La importación se realizó correctamente"
              }else{
                this.alert.tipo = "danger"              
                this.alert.mensaje = "La importación no se ha podido realizar. Por favor vuelva a intentarlo."
              }
              this.alertComponent.setType(this.alert.tipo);
              this.spinner.isRunning = false; 
              this.fileInputHistorica.nativeElement.value = "";
              this.fileInputAplicada.nativeElement.value = "";  
              datos.sobrescribir = false;
              this.historica.enviar = false;         
          })
          .subscribe(data => {
            
          }, error => {
            this.spinner.isRunning = false;  
            this.alert.visible = true;
            this.alert.titulo = datos.tipo == 0 ? "Cuenta Corriente Aplicada" : "Cuenta Corriente Historica";
            this.alert.tipo = "danger"  
            this.alertComponent.setType(this.alert.tipo);                        
            this.alert.mensaje = "La importación no se ha podido realizar. Por favor vuelva a intentarlo."
          });
  }
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/clientes/importar-archivos/importar-archivos.component.ts